/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoteUpdateDto } from '../../models/note-update-dto';

export interface UpdateNote$Params {
  entityId: string;
  entityClass: 'Form' | 'FormQualitySection';
  body: NoteUpdateDto;
}

export function updateNote(
  http: HttpClient,
  rootUrl: string,
  params: UpdateNote$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateNote.PATH, 'put');
  if (params) {
    rb.path('entityId', params.entityId, {});
    rb.path('entityClass', params.entityClass, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateNote.PATH = '/notes/{entityClass}/{entityId}';
